import React, { useState, useMemo } from 'react';
import './PanelGroup.scss';

const PanelGroup = ({ className, children, defaultActiveKey = '', ...props }) => {
  const [currentOpen, setCurrent] = useState(defaultActiveKey);
  const subComponents = useMemo(() => {
    if (!children) return children;
    else if (Array.isArray(children)) {
      return children.map(child => {
        if (!child) return child;
        const clonedChild = { ...child };
        clonedChild.props = {
          current: currentOpen,
          onChange: val => setCurrent(val),
          ...clonedChild?.props,
        };
        return clonedChild;
      });
    } else if (children && typeof children === 'object') {
      return {
        ...children,
        props: { current: currentOpen, onChange: val => setCurrent(val), ...children?.props },
      };
    }
    return children;
  }, [children, currentOpen, setCurrent]);
  return (
    <div {...props} className={`panel-group ${className || ''}`}>
      {subComponents}
    </div>
  );
};

export default PanelGroup;
